import { ROLE_LABELS } from 'utils/roles'

export const ROLE_OPTIONS = [
  { value: 'owner', label: ROLE_LABELS.owner, desc: 'Full control. Can manage this and everything inside it.' },
  { value: 'agent', label: ROLE_LABELS.agent, desc: 'Works on this on behalf of the Admin.' },
  { value: 'responsible_person', label: 'Responsible person', desc: 'Accountable for ongoing safety duties.' },
  { value: 'principal_accountable_person', label: 'Principal accountable person', desc: 'Lead accountable person under the Building Safety Act.' },
  { value: 'principal_designer', label: 'Principal designer', desc: 'Design-phase duty holder.' },
  { value: 'prospective_purchaser', label: 'Prospective purchaser', desc: 'Time-limited read access for due diligence.' },
]

export const DOMAIN_ROLE_OPTIONS = ROLE_OPTIONS.filter(r => r.value !== 'owner')

export const roleLabel = role => {
  const key = role && typeof role === 'object' ? role.value : role
  const known = ROLE_OPTIONS.find(r => r.value === key)
  if (known) return known.label
  if (role && typeof role === 'object') return role.label || (key ? String(key).replace(/_/g, ' ') : 'a role')
  return role ? String(role).replace(/_/g, ' ') : 'a role'
}
